export default "__VITE_ASSET__C7V2InBn__"